<template>
    <div class="col-md-5 col-lg-4 col-xl-3" style="padding: 1px;">
        <div class="side-wrapper p-4">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-wrapper py-3">
                    <div class="root-img d-flex">
                        <img
                        :src="$root.serverBasePath + '/verified.png'"
                        alt="Strata Connex"
                        height="40px"
                        />
                        <p class="ml-3 mb-0">
                        Verified by Strata Connex<br />
                        <span>100% Compliant</span>
                        </p>
                    </div>
                    <div class="sec-btn px-4 mt-2">
                        <button
                        @click="complianceExportAll()"
                        type="button"
                        class="btn btn-primary ml-3"
                        >
                        Export all
                        </button>
                    </div>
                    </div>
                </div>
            </div>

            <div class="detail-section py-5">
                <div class="row">
                    <div class="col-lg-12">
                      <DocumentInfoCard
                        v-if="contractor_details_loaded"
                        type="entity_details"
                        :cardData="contractor_details.active_business"
                        />
                        <DocumentInfoCard
                        v-if="contractor_details_loaded"
                        type="abn_acn"
                        :cardData="contractor_details.active_business"
                        />
                        <DocumentInfoCard
                        v-if="contractor_details_loaded"
                        type="license"
                        :cardData="contractor_details.active_business"
                        />
                        <DocumentInfoCard
                        v-if="contractor_details_loaded"
                        type="insurance"
                        :cardData="contractor_details.active_business"
                        />
                    </div>
                </div>
            </div> 
            <b-row>
                <b-col class="d-block d-lg-none">
                    <footer-component></footer-component>
                </b-col>
            </b-row> 
        </div>

        
    </div>
</template>

<script>
import _ from "lodash";
// todo move this to manager compliance page
import DocumentInfoCard from "@frontend/pages/manager/contacts/Contractors/view/ContractorDocuments/DocumentInfoCard.vue";
import FooterComponent from "../../../../../includes/FooterComponent.vue";


export default {
  components: {
    DocumentInfoCard,
    FooterComponent,
  },

  data() {
    return {
      contractor_details_loaded: false,
      contractor_details: {
        active_business: {},
      },
    };
  },
  mounted() {
    this.getDetails();
  },
  computed: {
    computeAbnAcnCardData() {
      return {
        title: "ABN/ACN",
        status: this.contractor_details.active_business.abn_acn_status,
        abn_acn: {
          abn_acn: this.contractor_details.active_business.abn_acn,
          company_name: this.contractor_details.active_business.company_name,
          abn_acn_info: this.contractor_details.active_business.abn_acn_info,
        },
      };
    },
    computeLicenseCardData() {
      let returnData = [];
      _.each(this.contractor_details.active_business.license, (license) => {
        returnData.push({
          title: "Contractor Licence",
          status: license.licence_status,
          license_info: license,
        });
      });
      return returnData;
    },
  },
  methods: {
    getDetails() {
      axios
        .post("api/manager/contacts/contractor/getDetails", {
          load_active_business: true,
          load_active_business_license: true,
          load_active_business_insurances: true,
          load_active_business_info: true,
          contractor_id: this.$route.params.id,
        })
        .then((response) => {
          this.contractor_details = response.data.contractor_details;
          this.contractor_details_loaded = true;
        });
    },
    complianceExportAll(){  
        let fileLink = document.createElement('a');
        fileLink.href = this.$root.serverBasePath + '/contractor/compliance/' + this.$route.params.id + '/exportAll';
        fileLink.setAttribute('download', 'download');
        document.body.appendChild(fileLink);
        fileLink.click();
          
    }
  },
};
</script>

<style scoped>
.side-wrapper {
    background-color: #eff0f6;
}
</style>